import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../../../../config';

export type GenerationEvent = {
  id: string;
  kind: string;
  message: string;
  source: string;
  data: Record<string, unknown> | null;
  createdAt: string;
};

type Response = {
  ok: true;
  events: GenerationEvent[];
  workflowStatus: string;
};

/**
 * Poll the append-only generation event stream while a workflow is being
 * authored. Used by the FlowDesigner's generation interstitial to show live
 * progress from any author agent (recording-author, direct-author, etc.).
 */
export function useWorkflowGenerationEvents(
  workflowId: string | null,
  opts: { enabled: boolean; poll?: boolean }
) {
  return useQuery({
    queryKey: ['workflow-generation-events', workflowId],
    enabled: Boolean(workflowId) && opts.enabled,
    refetchInterval: opts.poll === false ? false : opts.enabled ? 1500 : false,
    queryFn: async () => {
      if (!workflowId) throw new Error('Missing workflowId');
      const r = await fetch(`${API_URL}/org/workflows/${workflowId}/generation-events`, {
        credentials: 'include',
      });
      if (!r.ok) throw new Error('Failed to fetch generation events');
      const data = (await r.json()) as Response;
      if (!data.ok) throw new Error('Failed to fetch generation events');
      return data;
    },
  });
}
